<div class="expander-card">
            <div class="expandable-section" (click)="toggleTerms()"
            [ngClass]="{'expanded': isTermsExpanded, 'collapsed': !isTermsExpanded}">
            <span class="expandable-title">Uslovi korišćenja</span>
            <span class="condition-arrow" [ngClass]="{ 'rotate-arrow': isTermsExpanded }">
                <img src="{{ WHITE_ARROW_DOWN }}" />
            </span>
        </div>
    <div *ngIf="isTermsExpanded" class="terms">
        <p>MAX BET DOO NOVI SAD, sa sedištem u ulici Kisačka 82, Novi Sad (u daljem tekstu: MaxBet) je u
            agenciji za
            privredne
            registre u Srbiji zavedena pod brojem 07854293 priređuje Igre na sreću preko sredstava
            elektronske komunikacije
            u
            skladu sa odobrenjem br. 000-424-00-00317/2015 , izdatim od strane Ministarstva finansija
            Republike Srbije -
            Poreska
            uprava - sektora za menjačke i devizne poslove i igre na sreću, određuje pravila, uslove
            učestvovanja u igri i
            zadržava pravo izmena ovih uslova u bilo kom trenutku bez prethodnog obaveštenja. Za sve promene
            pravila i
            uslova
            koji budu usledili, MaxBet se obavezuje da će obavestiti klijente putem emaila ili putem
            obaveštenja koje će
            biti
            istaknuto na sajtu www.maxbet.rs. MaxBet zadržava pravo da odbije opklade, delom ili u celosti
            bez objašnjenja,
            i da
            nakon uplate proglasi nevažećim kvotu koja je posledica greške od strane sistema ili
            priređivača, a ulog vrati
            igraču.</p>
        <p> Opklade se primaju po Zakonima Republike Srbije.</p>

        <p>Registracija i klađenje je zabranjeno osobama mlađim od 18 godina. Prihvatanjem ovih pravila
            učesnik potvrđuje
            da
            ima više od 18 godina.</p>
        <p>U slučaju da maloletno lice na neki nedozvoljeni način ipak otvori nalog na MaxBet web servisu,
            priređivač se
            obavezuje da će odmah po otkrivanju blokirati nalog maloletne osobe, uz napomenu da nema obavezu
            vraćanja
            uplaćenog
            depozita. MaxBet zadržava pravo da odbije zahtev za otvaranje naloga za klađenje i zadržava
            pravo da zatvori
            račun
            klijenta po sopstvenom nahođenju. Upotreba servisa može u potpunosti ili delimično da bude
            ograničena u nekim
            geografskim oblastima. MaxBet ne snosi odgovornost za registracije na servis i upotrebu servisa
            od strane
            korisnika
            sa teritorija na kojima je upotreba servisa zabranjena.</p>
        <h6>Otvaranje naloga</h6>

        <p>Nakon prihvatanja Pravila i uslova korišćenja, otvoriće se strana na kojoj se traže podaci za
            otvaranje naloga
            za
            korišćenje servisa koji uključuju: ime, prezime, matični broj, datum rođenja, važeću e-mail
            adresu, korisničko
            ime i
            lozinku, broj telefona, grad i zemlju. Za tačnost podataka odgovornost snosi lice koje otvara
            nalog. Neophodno
            je da
            je osoba koja se registruje starija od 18 godina, te da prihvata opšte uslove i politiku
            privatnosti MaxBet
            kladionice.</p>
        <p>Kada popunite sva obavezna polja i pošaljete zahtev za registraciju i otvaranje naloga na MaxBet
            web servisu,
            dobićete e-mail na Vašu e-mail adresu (koju ste prethodno registrovali na našoj aplikaciji) i od
            Vas će se
            tražiti
            da potvrdite svoju registraciju tako što ćete kliknuti na odgovarajući aktivacioni link. Nakon
            uspešne
            aktivacije,
            Vaš nalog će biti spreman i možete da počnete da koristite MaxBet online klađenje. Vrlo je važno
            da podaci koje
            ostavljate budu tačni i ispunjeni od strane osobe koja se registruje.</p>
        <p> MaxBet zadržava pravo da ne otvori ili zatvori nalog, ukoliko su informacije nepotpune ili
            netačne. Jednom
            igraču je
            dozvoljeno da otvori jedan nalog. Otvaranje više naloga nije dozvoljeno.</p>
        <p>Ukoliko MaxBet ima sumnje da je neko od klijenata otvorio više naloga, MaxBet ima pravo da
            zamrzne nalog
            klijenta
            ili da zatvori nalog odmah, a klijent gubi sve svoje podatke i stanja.</p>
        <ul><b> Izričito je zabranjeno klijentima da:</b>
            <li>Igraju za treća lica.</li>

            <li>Deponuju novac koji potiče od kriminalne aktivnosti.</li>

            <li>Deponuju novac sa kartice za čije korišćenje nemaju ovlašćenje, ili svesno primaju novac sa
                kartice od
                drugih
                ili
                trećih lica i prosleđuju na svoj nalog.</li>

            <li>Koriste svoj nalog za bilo kakvo pranje novca ili bilo koje druge nezakonite radnje.</li>
        </ul>
        <p> Strogo je zabranjeno korišćenje nedozvoljenih radnji tipa nedozvoljeno menjanje programa,
            presecanje podataka,
            korišćenje raznih elektronskih, mehaničkih i drugih naprava koje donose odluke u bilo kojoj igri
            ili menjanje
            podataka kada je igra počela od strane vlasnika naloga ili nekoga za druga ili treća lica.</p>
        <p> MaxBet u slučaju bilo kakve sumnje na nedozvoljenu igru nije u obavezi da isplati dobitke i može
            teretiti
            sudskim putem takvog klijenta kao vršioca nedozvoljenih radnji po važećim zakonima.</p>
        <p>Da bi koristio usluge MaxBet web servisa, klijent mora imati važeći nalog sa dovoljnim sredstvima
            da može
            učestvovati u igri.</p>
        <p>
            Zahtev za otvaranje naloga se vrši popunjavanjem registracionog formulara.</p>
        <p>
            Minimalna uplata po nalogu je 20 dinara, a maksimalna isplata 5.000.000 dinara.</p>
        <p>
            MaxBet zadržava pravo da po svom nahođenju izmeni visinu minimalne uplate/isplate depozita po
            nalogu.</p>
        <p>
            MaxBet ne naplaćuje dodatne takse ili provizije na uplate depozita, osim onih koje banka naplati
            pri transakciji
            novca sa računa ili na račun klijenta (igrača).</p>
        <p>Sredstva deponovana na jedan nalog ne mogu biti deponovana na drugi nalog.</p>
        <p>Isplata depozita se vrši na bankovni račun igrača ili direktno na uplatnim mestima kladionica
            MaxBet uz
            prethodnu
            najavu o podizanju novca, a koja uključuje i lokaciju.</p>
        <p>MaxBet zadržava pravo da od igrača u bilo kom trenutku zatraži lični dokument u cilju utvrđivanja
            identiteta i
            starosti igrača. Priloženi lični dokument (kopiju kartice, računa, lične karte, pasoša, vozačke
            dozvole i dr.)
            mora
            biti izdat od zvanične institucije, a podaci na dokumentu moraju biti prikazani jasno i
            čitljivo. Takođe
            zadržava
            pravo da zahteva po potrebi dodatne informacije od igrača. <b>Potrebne dokumente igrač može
                priložiti u
                elektronskoj
                formi na e-mail:
                online&#64;maxbet.rs</b></p>
        <p>
            Ako iz bilo kog razloga korisnik odbije ili nije u mogućnosti da bilo koji od traženih
            dokumenata dostavi,
            MaxBet
            zadržava pravo da zamrzne ili zatvori nalog, a korisnik gubi sve svoje dobitke i podatke.
            Sigurnost MaxBet
            naloga je
            isključivo briga korisnika. Korisnik ne sme dozvoliti pristup trećim licima svom nalogu.
            Korisnik je odgovoran
            da
            čuva u tajnosti lozinku koja omogućava pristup MaxBet nalogu. Korisnik je u obavezi da se po
            završetku
            korišćenja
            servisa na javnim mestima i deljenim računarima odjavi sa svog MaxBet naloga, i spreči treća
            lica da pristupe i
            koriste njegov MaxBet nalog.</p>
        <p>
            Korisnik prihvata potpunu odgovornost za sve posledice ukoliko svesno ili nesvesno dozvoli
            korišćenje svog
            naloga
            trećim licima.</p>
        <p>
            U slučaju da klijent posumnja ili ima saznanja da postoji mogućnost zloupotrebe njegovog naloga,
            u obavezi je da
            elektronskim putem (e-mail) i <b> pozivom call centra 011 44 22 444</b> prijavi nameru
            zloupotrebe i zatraži
            blokiranje
            svog naloga.</p>
        <p>
            MaxBet garantuje tajnost Vaših podataka i obavezuje se da Vaše lične podatke neće prosleđivati
            trećim licima,
            bez
            Vašeg saznanja i izričite dozvole. Vaši lični podaci mogu biti dati na uvid trećim licima samo
            na zahtev
            nadležnih
            državnih institucija. Bilo kakav nagoveštaj pranja novca MaxBet će prijaviti nadležnim organima.
            Ukoliko ne
            koristite svoj nalog 6 meseci od zadnjeg dana korišćenja MaxBet može zatvoriti nalog i o tome
            putem e-mail-a
            obavestiti klijenta. MaxBet zadržava pravo da posle 6 meseci nekorišćenja naloga sredstva
            prebaci na svoj račun
            i
            prosledi ih u <b>HUMANITARNE SVRHE</b>. Sve informacije i pitanja u vezi zatvaranja računa
            možete dobiti na
            e-mail:
            online&#64;maxbet.rs</p>
        <p>
            MaxBet postavlja uslove visine uplate kao i isplate, limitiranja tiketa, primanja i ne primanja
            uplate,
            isključivanja korisnika na određeno ili neodređeno vreme.</p>
        <p>
            MaxBet zadržava pravo promene limita uplate i isplate, a bez obaveze da o tome obavesti svoje
            klijente.</p>
        <p>
            Minimalni ulog iznosi 20 dinara po tiketu. Neophodna sredstva za korišćenje sistema moraju biti
            deponovana na
            nalog
            vlasnika naloga pre korišćenja. Korisnik izjavljuje da ne zna ili nije svestan ishoda događaja
            prilikom
            postavljanja
            odgovarajuće opklade. Početak utakmice se može menjati u zavisnosti od vremena početka utakmica
            i na to ne utiče
            MaxBet.</p>
        <p> Obaveštenje o obradi podataka o ličnosti možete pogledati <a
                href="https://downloadsection.net/public/assets/docs/Obaves%CC%8Ctenje%20o%20obradi%20podataka%20o%20lic%CC%8Cnosti%20i%20o%20pravu%20na%20prigovor.pdf"
                target="_blank"> OVDE</a>.</p>
    </div>

        <div class="expandable-section" (click)="togglePrivacy()"
            [ngClass]="{'expanded': isPrivacyExpanded, 'collapsed': !isPrivacyExpanded}">
            <span class="expandable-title">Maxbet Loyalty</span>
            <span class="condition-arrow" [ngClass]="{ 'rotate-arrow': isPrivacyExpanded }">
                <img src="{{ WHITE_ARROW_DOWN }}" />
            </span>
        </div>

    <div *ngIf="isPrivacyExpanded">
        <p>MAX BET DOO NOVI SAD, sa sedištem u ulici Kisačka 82, Novi Sad (u daljem tekstu: MaxBet) je u
            agenciji za
            privredne
            registre u Srbiji zavedena pod brojem 07854293 priređuje Igre na sreću preko sredstava
            elektronske komunikacije
            u
            skladu sa odobrenjem br. 000-424-00-00317/2015 , izdatim od strane Ministarstva finansija
            Republike Srbije -
            Poreska
            uprava - sektora za menjačke i devizne poslove i igre na sreću, se obavezuje da štiti i poštuje
            privatnost
            registrovanih korisnika. Podaci koji su dostavljeni za registraciju od korisnika se čuvaju u
            tajnosti za naše
            svrhe
            radi korišćenja Maxbet Web servisa, i služe samo za namenu za koju se daju. Ove podatke MaxBet
            ne razmenjuje sa
            trećim licima. Mail adrese se mogu koristiti jedino za to da se našim registrovanim korisnicima
            dostave
            informacije
            o uslugama koje pruža MaxBet. Podaci se mogu dati trećim licima isključivo ukoliko to nalože
            državni organi, za
            potrebe sudskih postupaka i u drugim slučajevima, a sve u skladu sa zakonom ili drugim propisom.
        </p>

        <h4>Prikupljanje informacija</h4>
        <p>Saglasni ste sa prikupljanjem, prenosom i čuvanjem tih informacija od strane Priređivača.
            Informacije i podaci o
            Vama koje možemo prikupljati, koristiti i obrađivati obuhvataju sledeće:</p>
        <ol>
            <li>Informacije koje nam prosleđujete preko aplikacije ili elektronskom poštom;</li>
            <li>Evidencija o komunikaciji, bilo putem aplikacije, elektronske pošte, telefona ili drugih
                sredstava;</li>
            <li>Vaši odgovori na ankete ili ispitivanja korisnika koja sprovodimo;</li>
            <li>Detalji o Vašim posetama aplikaciji, uključujući, između ostalog, domen i host preko koga
                pristupate
                internetu,
                Vašu IP adresu, pretraživač, operativni sistem i poseban softver koji koristite, vreme i
                datum Vašeg
                pristupa, URL
                lokacije preko čije spoljne veze dolazite na našu aplikaciju kada nas posećujete, podatke o
                lokaciji,
                veblogovima i
                ostale podatke vezane za komunikaciju. Takođe, možemo prikupljati informacije u vezi sa
                Vašim aktivnostima
                vezanim
                za korišćenjem našeg proizvoda;</li>
            <li>Informacije mogu obuhvatati ime i prezime, adresu, adresu elektronske pošte, mesto
                stanovanja, pol, nadimak,
                konfekcijski broj i broj telefona, informacije o obliku identifikacije koji se koristi, a
                sve u skladu sa
                važećim
                propisima.</li>
        </ol>
        <h4>Korišćenje informacija</h4>
        <p> Vaše lične podatke i informacije zajedno sa ostalim informacijama možemo koristiti u sledeće
            svrhe:</p>
        <ol>
            <li>Obrada Vaših opklada;</li>
            <li> Otvaranje, rukovođenje i upravljanje Vašim online nalogom;</li>
            <li>Potvrđivanje bilo koje informacije koju prosledite kako bismo postigli, vodili i očuvali
                kontinuitet svih
                aktivnosti na online nalogu;</li>
            <li>Poštovanje zakonskih obaveza uključujući i one čiji je cilj sprečavanje pranja novca;</li>
            <li>Izrada ličnih profila;</li>
            <li>Sprovođenje ispitivanja korisnika, anketa i analiza;</li>
            <li>Upućivanje informacija o promotivnim ponudama i o našim proizvodima i usluga, ukoliko ste za
                to dali svoj
                pristanak;</li>
            <li>Praćenje transakcija u okviru online naloga u cilju sprečavanja nepropisnog klađenja, pranja
                novca i
                varanja;</li>
            <li>Stavljanje na raspolaganje proizvoda i usluga i pomoć u pružanju istih, kao i pomoć u
                razvoju i poboljšanju
                usluga;</li>
            <li>Čuvanje Vaših ličnih podešavanja, preferencija i drugih informacija i praćenje konkretnih
                aktivnosti na
                našoj
                aplikaciji;</li>
            <li>Sticanje uvida u efektivnost naših promotivnih kampanja;</li>
            <li> Utvrđivanje izvora sa koga ste pristupili našoj aplikaciji</li>
            <li>Vođenje aplikacije i poboljšanje korisničkog iskustva i upravljanje poslovanjem.</li>
        </ol>
        <h4>Politika kolačića i internet tehnologija</h4>
        <p>Kolačići su male tekstualne datoteke koje dospevaju na Vaš računar tako što posećujete određene
            vebsajtove ili
            otvarate određene poruke u elektronskoj pošti. Njihovo korišćenje je rasprostranjeno i namenjeno
            poboljšanju
            rada
            vebsajtova ili samom funkcionisanju istih, i to u cilju efikasnijeg pružanja poslovnih ili
            marketinških
            informacija.
            Korisnik može upravljati kolačićima (podešavanjima). Ispisuju se ili očitavaju isključivo oni
            kolačići koji se
            zasnivaju na preferencijama korisnika. Ukoliko Vaš pretraživač ne podržava JavaScript,
            korišćenjem kolačića
            možete
            upravljati isključivo preko podešavanja Vašeg internet pretraživača. Obratite pažnju na to da
            ukoliko
            deaktivirate
            sve kolačiće preko Vašeg pretraživača, to može ograničiti funkcionalnost opcija na aplikaciji.
        </p>
        <h4> Odavanje informacija</h4>
        <p>MaxBet će preduzeti sve neophodne korake u cilju očuvanja Vaših informacija bezbednim i
            zaštićenim.
            Prikupljanje Vaših podataka koji su Vam traženi i sa čime ste se saglasili se vrši u skladu sa
            zakonom i podaci
            koje
            ste nam dali se mogu koristiti isključivo za poboljšanje naših usluga.
            Prikupljeni podaci će biti dostupni regulatornim, sportskim i drugim nadležnim organima,
            uključujući policiju, u
            cilju sprovođenja istražnih radnji vezanih za prevare, pranje novca ili probleme sa integritetom
            u sportu, kao i
            radi poštovanja naših zakonskih obaveza.</p>
        <br>
        <h4>Povlačenje saglasnosti</h4>
        <p>Imate pravo da povučete saglasnost o korišćenju u svakom trenutku, tako što ćete nam se obratiti
            tim povodom.
            Odmah po povlačenju korisnikove saglasnosti, prestaćemo sa korišćenjem pomenutih informacija
            osim ukoliko nam
            zakon
            ne nalaže da nastavimo sa njihovim korišćenjem.
            U evidenciji čuvamo korisničku istoriju (aktivnost na online nalogu) u skladu sa našom politikom
            o čuvanju
            podataka.
            Nakon isteka predviđenog perioda, Vaše informacije trajno će biti uklonjene.
            Lice za zaštitu podataka o ličnosti kod Rukovaoca:</p>
        <p>Email: dpo&#64;maxbet.rs</p>
        <p>Kontakt telefon: 062/515-497</p>
    </div>
</div>